// Module
var code = "<div class=\"scrollContent\">\n    <span class=\"dynAppsLaunchDialog\">\n        <select id=\"stateInput\"></select>\n    </span>\n</div>\n<div data-type=\"horizontal\" data-role=\"controlgroup\">\n    <a id=\"continueButton\" href=\"#\" data-role=\"button\" data-i18n=\"common::continue.title\"></a>\n</div>";
// Exports
module.exports = code;